'use strict';

/* global $ */

let jobs_url = '/wp-json/wp/v2/metiers';
let jobs_data = [];

export class AutocompleteService {
    constructor (searchItem, callback) {
        $.get(jobs_url, {
            search: searchItem
        }, function (data) {
            let jobs = [];
            $.each(data, (i, el) => {
                let job = el.acf;
                // adding label for autocomplete list
                job.label = el.acf.metier;
                jobs.push(job);
            });
            jobs.sort(function (a, b) { return a.metier.localeCompare(b.metier) });
            jobs.sort(function (a, b) { return a.speciality.localeCompare(b.speciality) });
            callback(jobs);
        });
    }
}



// WEBPACK FOOTER //
// ./front/js/services/AutocompleteService.js